import { AppEvent, appEventEmitter } from "@shared/events/app-event-emitter";
import { usePostHog } from "posthog-js/react";
import { useCallback, useEffect } from "react";

export const PostHogEventListener = () => {
  const posthog = usePostHog();

  const listener = useCallback(
    (data: { [key: string]: any }, eventType: AppEvent["eventType"]) => {
      if (eventType === "sidekick-auth-identify-user") {
        const {
          trackingId,
          firstName,
          lastName,
          mlsProviders,
          subscriptionPlanId,
          roles,
        } = data;
        posthog.identify(trackingId, {
          name: `${firstName} ${lastName}`.trim(),
          mls_providers: mlsProviders,
          subscription_plan_id: subscriptionPlanId,
          roles,
        });
        return;
      }

      posthog.capture(eventType, data);

      if (eventType === "sidekick-auth-logout") {
        posthog.reset();
      }
    },
    [posthog],
  );

  useEffect(() => {
    appEventEmitter.addGlobalListener(listener);
    return () => {
      appEventEmitter.removeGlobalListener(listener);
    };
  }, [listener]);

  return null;
};
